<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="my-3 h3 text-center" >
                <template #default>ویدیوکلیب   </template>
                </m-div><m-posts-1 v-bind='{...{"cardLink":true,"slicer":null,"contentType":"post","paginate":true,"categoryPanel":false,"flatCategoriesShape":false,"contentCategories":["\u06a9\u0644\u06cc\u0628"],"postCard":"mPostCard313","postCardClass":"mb-2 col-lg-12 col-md-12","stores_filter":null},...{}}' :style='""' class="" >
                <template #p-1>p-1   </template>
                
                <template #p-2>p-2   </template>
                </m-posts-1></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mPosts1 from '@moeinmdn/miw-alpha-components/src/package/Post/Posts/Posts1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mPosts1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
